import { Editor, Element as SlateElement, Range, Transforms } from 'slate';

const LINK_PROTOCOLS = ['http:', 'https:', 'mailto:'];

const isLinkNode = (node) => !Editor.isEditor(node) && SlateElement.isElement(node) && node.type === 'link';

// Only absolute http, https and mailto (with an address) may become links.
export const isValidLinkUrl = (url) => {
    try {
        const { protocol, pathname } = new URL(url.trim());
        if (protocol === 'mailto:') return pathname.trim() !== '';
        return LINK_PROTOCOLS.includes(protocol);
    } catch {
        return false;
    }
};

// Links are inline elements: they sit inside a paragraph, between text nodes.
export const withInlines = (editor) => {
    const { isInline } = editor;
    editor.isInline = (element) => element.type === 'link' || isInline(element);
    return editor;
};

// Link element under the selection, or null.
export const getActiveLink = (editor) => {
    if (!editor.selection) return null;
    const [match] = Editor.nodes(editor, { match: isLinkNode });
    return match ? match[0] : null;
};

// Points the link under the selection to `url`, or creates one: around the selected text, or
// showing the URL itself at a collapsed selection.
export const upsertLink = (editor, url) => {
    if (!editor.selection) return;
    if (getActiveLink(editor)) {
        Transforms.setNodes(editor, { url }, { match: isLinkNode });
        return;
    }
    if (Range.isCollapsed(editor.selection)) {
        Transforms.insertNodes(editor, { type: 'link', url, children: [{ text: url }] });
        return;
    }
    Transforms.wrapNodes(editor, { type: 'link', url, children: [] }, { split: true });
};

// Turns the link under the selection back into plain text.
export const unwrapLink = (editor) => {
    Transforms.unwrapNodes(editor, { match: isLinkNode });
};
